/**
 * @generated SignedSource<<44a3f9fedd427b060aadd55b58533d37>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserRecommendationsGrid_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UserRecommendationsRecommendationTile_viewer">;
  readonly " $fragmentType": "UserRecommendationsGrid_viewer";
};
export type UserRecommendationsGrid_viewer$key = {
  readonly " $data"?: UserRecommendationsGrid_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserRecommendationsGrid_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserRecommendationsGrid_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "fetchFavorites",
          "value": true
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "UserRecommendationsRecommendationTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "233204a50d8db58ef58fc8723450d25c";

export default node;
